export const validateUrl = str => {
  const re = /[^a-z0-9/]+/gi;

  let strFormatted = `${str.replace(re, "-").toLowerCase()}`;

  return strFormatted;
};
